import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Loader from "./components/Loader";
import Home from "./pages/Home";
import Sidebar from "components/Sidebar";
import Chat from "pages/Chat";
import Login from "pages/Login";
// import Cookies from 'js-cookie';
import { withCookies, Cookies } from 'react-cookie';

import jwt from 'jsonwebtoken'

const userPrefersDark =
	window.matchMedia &&
	window.matchMedia("(prefers-color-scheme: dark)").matches;

function App() {
	// const navigate = useHistory();
	const [appLoaded, setAppLoaded] = useState(false);
	const [startLoadProgress, setStartLoadProgress] = useState(false);
	const [isLoggedIn, setIsLoggedIn] = useState(false);

	useEffect(() => {
		if (userPrefersDark) document.body.classList.add("dark-theme");
		stopLoad();
	}, []);

	const stopLoad = () => {
		setStartLoadProgress(true);
		setTimeout(() => setAppLoaded(true), process.env.REACT_APP_FRONT_PORT);
	};

	// const handleLogin = () => {
	// 	setIsLoggedIn(true)
	// }
	const handleLogin = () => {
		const cookies = new Cookies();
		const token = cookies.get('_auth');
		console.log('Token', token);
		if (token) {
		  // If the token exists, decode it and check if it is valid
		  try {
			const decoded = jwt.decode(token);
			console.log('JWT decoded: ' + JSON.stringify(decoded))
			if (decoded.exp > Date.now() / 1000) {
			  // If the token is not expired, set isAuthenticated to true
			  console.log('checked token expiry all ok, setting setIsLoggedIn to true')
			  setIsLoggedIn(true)
			  
			}
		  } catch (err) {
			// If the token is invalid, do nothing
			console.log(err)
		  }
		}
	
	  };

	// if (!appLoaded) return <Loader done={startLoadProgress} />;


	return (
	<div className="app">		
		{!isLoggedIn ? (
		  <Login onLogin={handleLogin} />
		) : (
		<div >
			<p className="app__mobile-message">WhatsApp Web like</p>
		
					<Router>
						<div className="app-content">
							<Sidebar />
							<Switch>
								<Route path="/chat/:id" component={Chat} />
								<Route component={Home} />
							</Switch>
						</div>
					</Router>
			
		</div>
		)}
    </div>
	);

}

export default withCookies(App);